const ruBreadcrumbsMapper = (path) => {
    return urls[path];
};
const settings = 'globalSettings.breadcrumbs.global_settings';

const urls = {
    '/global-settings/separate': [{ru: settings, link: ''}, {ru: 'globalSettings.breadcrumbs.separate_functionality', link: ''}],
};

export default ruBreadcrumbsMapper;